import { z } from 'zod'
import { RewardCategory } from '~library/enums'

export const suitCourtesyListSchema = z.object({
  /** 分類 */
  type: z.string(),
  /** 券號 */
  couponNo: z.string()
})
export const benefitAndVoucherManagementGetFlightSegmentCouponListSchema =
  z.object({
    /** 指派禮遇Id */
    id: z.string(),
    /** 禮遇商品Id */
    commodityId: z.string(),
    /** 券號 */
    couponNo: z.string(),
    /** 使用效期 */
    validityTime: z.string(),
    /** 分類選項 */
    classType: z.nativeEnum(RewardCategory),
    /** 分類次選項 */
    classSecondType: z.string(),
    /** 分類第三選項 */
    classThirdType: z.string(),
    /** 使用說明與注意事項PDF檔案Id[英文] */
    englishDescFileId: z.string(),
    /** 使用說明與注意事項PDF檔案Id[簡體中文] */
    simplifiedDescFileId: z.string(),
    /** 使用說明與注意事項PDF檔案Id[繁體中文] */
    traditionalDescFileId: z.string(),
    /** 套裝禮遇 */
    suitCourtesy: z.array(suitCourtesyListSchema)
  })

export interface BenefitAndVoucherManagementGetFlightSegmentCouponList
  extends z.infer<
    typeof benefitAndVoucherManagementGetFlightSegmentCouponListSchema
  > {}
